import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { applyTheme } from './lib/theme.ts';
import { registerServiceWorker } from './lib/push.ts';
import './styles/app.css';

// Stamp the theme before first paint so a dark-mode user never sees a white flash.
applyTheme();
registerServiceWorker();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
